var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArmyIconPlain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.750977 5.16601C0.750977 2.40459 2.98955 0.166016 5.75098 0.166016H11.8662C14.6276 0.166016 16.8662 2.40459 16.8662 5.16602V13.0739C16.8662 15.0121 15.7461 16.7756 13.9918 17.5996L10.9341 19.0356C9.58767 19.668 8.02952 19.668 6.68303 19.0356L3.62542 17.5996C1.8711 16.7756 0.750977 15.0121 0.750977 13.0739V5.16601Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.437 7.59374H10.4105L8.82342 3.27051L7.29512 7.59374H3.23926L6.67793 10.0936L5.38475 14.4462L8.83812 11.9464L12.2768 14.4462L11.013 10.1083L14.437 7.59374Z",
    fill: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmyIconPlain);
export default __webpack_public_path__ + "static/media/armyIconPlain.7ed333d65f761dfd3ae2e012da909843.svg";
export { ForwardRef as ReactComponent };